import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { BookingSheetFormProps } from "./types";

export default function BookingSheetBlockForm({
  formState,
  onFieldChange,
}: BookingSheetFormProps) {
  const { t } = useTranslation("admin");
  const { blockReason, blockDescription } = formState;

  return (
    <div className="space-y-3 border-t border-border pt-3">
      <div>
        <Label className="text-xs">{t("bookingSheet.reason")}</Label>
        <Select value={blockReason} onValueChange={(v) => onFieldChange("blockReason", v)}>
          <SelectTrigger className="h-9 text-sm"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="maintenance">{t("bookingSheet.maintenance")}</SelectItem>
            <SelectItem value="event">{t("bookingSheet.event")}</SelectItem>
            <SelectItem value="closed">{t("bookingSheet.closed")}</SelectItem>
            <SelectItem value="other">{t("bookingSheet.other")}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="text-xs">{t("bookingSheet.description")}</Label>
        <Textarea
          value={blockDescription}
          onChange={(e) => onFieldChange("blockDescription", e.target.value)}
          className="text-sm"
          rows={2}
          placeholder={t("bookingSheet.optionalDescription")}
        />
      </div>
    </div>
  );
}
